export default __webpack_public_path__ + "static/media/graphic-03.9233bf93.png";